<app-register [recover]="true"></app-register>
